import 'jquery';

export class GlobalMenu {
    constructor() {
        this.json = [];
        this.objects = [];
    }

    setJson(json) {
        this.json = json;
    }

    addObject(o) {
        this.objects.push(o);
    }

    addObjectsFromJson() {
        if (typeof this.json === "undefined" || this.json === null) {
            return;
        }

        for (var i = 0, nr = this.json.length; i < nr; i++) {
            var object = this.json[i];
            this.addObject(object);
        }
    }

    html() {
        this.addObjectsFromJson();

        var html = '<ul class="sidebar-nav">';
        for (var i = 0, nr = this.objects.length; i < nr; i++) {
            var object = this.objects[i];
            html += this.createMenuLi(object);
        }
        html += '</ul>';
        return html;
    }

    createMenuLi(object) {
        var html = '';
        if (typeof object.type !== 'undefined') {
            html += '<li role="separator" class="divider"></li>';
        }
        else if (typeof object.html !== 'undefined') {
            html += object.html;
        }
        else {
            var itemLink = '';
            if (typeof object.Url === 'undefined' || object.Url === null) {
                if (typeof object.Name !== "undefined") {
                    itemLink = object.Name;
                }
            }
            else {
                var title = typeof object.Tooltip !== 'undefined' ? ' title="' + object.Tooltip + '"' : '';
                itemLink = '<a href="' + object.Url + '"' + title + '><span class="unify-global-menu-link-text">' + object.Name + '</span></a>';
            }

            var isActiveHtml = '';
            if (typeof object.IsActive !== 'undefined' && object.IsActive !== null && object.IsActive === true) {
                isActiveHtml = ' class="unify-active"';
            }
            html += '<li' + isActiveHtml + '>' + itemLink + '</li>';
        }
        return html;
    }

    setGlobalMenu(json) {
        this.setJson(json);
        this.addGlobalMenu(this.html());

        // If there are menu items that should only be visible in the hamburger menu force the hamburger to always be visible.
        if ($.grep(json, function (mi) { return mi.DisplayLocation === 'Hamburger'; }).length > 0) {
            $('.globalmenu-toggler').addClass('visible-xs-inline-block visible-sm-inline-block visible-md-inline-block visible-lg-inline-block');
        }
    }

    addGlobalMenu(unifyMenu) {
        // remove old
        $('#globalmenu-wrapper .unify-globalmenu-menu,' +
            '.unify-globalmenu-other-links').remove();
        // add new
        $('#globalmenu-wrapper').append('<div class="unify-globalmenu-menu">' + (unifyMenu === null ? '' : unifyMenu) + '</div>');
    }

    addClickOutsideOfGlobalMenuHidesIt() {
        $(document)
            .click(function (event) {
                // if show button is clicked, do nothing
                if ($(event.target).closest('.globalmenu-toggler').length) {
                    return;
                }

                if (!$(event.target).closest('#globalmenu-wrapper').length) {
                    if ($('#globalmenu-wrapper').is(":visible")) {
                        $('#globalmenu-wrapper').addClass('unify-hidden');
                        $('.globalmenu-toggler').removeClass('open');
                    }
                }
            });
    }
}
